<template>
  <div class="login">
    <h1>
      <EALogo />
      <p>Digital Asset Manager</p>
    </h1>
    <language-switcher />
    <form action="" class="login-form" @submit.prevent="login">
      <div class="error" v-if="error">
        {{ error }}
      </div>
      <label for="email">{{ $t('login.email') }}:</label>
      <input v-model="email" type="email" name="email" id="email" :placeholder="$t('login.emailPlaceholder') + '...'">

      <label for="password">{{ $t('login.password') }}:</label>
      <input v-model="password" type="password" name="password" id="password" :placeholder="$t('login.passwordPlaceholder') + '...'">

      <input type="submit" :value="$t('login.login').toUpperCase()" :disabled="disabled">
    </form>
  </div>
</template>

<script>
import EALogo from '@/assets/images/electrifyamerica_logo.svg'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import { LOGIN } from '@/store/actions.type'

export default {
  components: {
    EALogo,
    LanguageSwitcher
  },
  data() {
    return {
      email: null,
      password: null,
      error: null,
      disabled: false
    }
  },
  methods: {
    login() {
      this.disabled = true
      this.error = null
      this.$store.dispatch(LOGIN, {
        email: this.email,
        password: this.password
      }).then(() => {
        this.$router.push(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }).catch(err => {
        // console.log(err)
        this.error = err
        this.disabled = false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  color: #fff;
  background-color: #0B0F4D;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
h1 {
  font-size: 1em;
  font-weight: 300;
  text-align: center;
  margin-bottom: 55px;
  width: 156px;

  p {
    margin: 7px 0 0;
  }
}
.error {
  color: #EB3323;
  background-color: lighten(#EB3323, 40%);
  border: 1px solid #EB3323;
  border-radius: 4px;
  margin-bottom: 25px;
  padding: 10px;
}
label {
  display: block;

  & ~ & {
    margin-top: 45px;
  }
}
form {
  width: 400px;

  input {
    display: block;
  }
}
input[type=submit] {
  margin-top: 50px;
}
.language-switcher {
  margin-bottom: 40px;
  
  /deep/ {
    li {
      display: inline-block;
      padding: 10px 22px;

      &.active {
        border-bottom: 3px solid;
      }
      &.title {
        display: none;
      }
    }
  }
}
</style>
